import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function workingHoursReducer() {
    return combineReducers({
        WorkingHours_ListSubForPO: createItemReducer("WorkingHours", "PersonalCard.ListSubForNewPO", false),
        WorkingHours_ListSubForPOParams: createItemReducerParams("WorkingHours", "PersonalCard.ListSubForNewPO"),
        WorkingHours_ChartData: createItemReducer("WorkingHours", "Reports.lckCalcTimeByDivisionForWeb", false),
        WorkingHours_ChartDataParams: createItemReducerParams("WorkingHours", "Reports.lckCalcTimeByDivisionForWeb")
    });
}